import {http_client} from "@/plugins/http_client";

const getFamiliarPersona = async (param) => await http_client('/api/v1/familiar',param,'get')
const postFamiliar = async (body) => await http_client('/api/v1/familiar',body,'post')
const deleteFamiliar = async (id_familiar_persona) => await http_client(`/api/v1/familiar/${id_familiar_persona}`,{},'delete')

const getReferenciaPersonal = async (id_persona,param) => await http_client(`/api/v1/persona/referencia-persona/${id_persona}`,param,'get')
const postRefereciaPersonal = async (id_persona,body) => await http_client(`/api/v1/persona/referencia-persona/${id_persona}`,body,'post')
const deleteReferenciaPersonal = async (id_refencia) => await http_client(`/api/v1/persona/referencia-persona/${id_refencia}`,{},'delete')

const getContactoEmergencias = async (id_persona,param) => await http_client(`/api/v1/persona/contacto-emergencia/${id_persona}`,param,'get')

export default{
    getFamiliarPersona,
    postFamiliar,
    deleteFamiliar,
    
    getReferenciaPersonal,
    postRefereciaPersonal,
    deleteReferenciaPersonal,

    getContactoEmergencias
}